import { Modal, SxProps, Theme } from "@mui/material";
import React, { useState } from "react";
import TextField from "./TextField";
import AIIcon from "../img/AI.svg";
import TextPromptModal from "./TextPromptModal";
import {
    hideLanguageSwitcher,
    showLanguageSwitcher,
} from "../utils/languageUtils";

interface Props {
    variant?: "contained" | "outlined";
    placeholder?: string;
    value?: string;
    width?: number | string;
    fullWidth?: boolean;
    setText?: (val: string) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onChange?: (val: string) => void;
    error?: boolean;
    helperText?: string;
    sx?: SxProps<Theme>;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    businessType: string;
    language?: string;
}

export interface DisplayMessage {
    role: "user" | "assistant";
    content: string;
}

const AITextField = React.forwardRef((props: Props, ref) => {
    const {
        variant,
        placeholder,
        value,
        width,
        fullWidth,
        setText,
        onFocus,
        onBlur,
        error,
        helperText,
        sx,
        onKeyDown,
        onChange,
        businessType,
        language = "English",
    } = props;

    const [showModal, setShowModal] = useState(false);
    const [displayHistory, setDisplayHistory] = useState<DisplayMessage[]>([]);

    const showAI = () => {
        hideLanguageSwitcher();
        setShowModal(true);
    };

    const onCancel = () => {
        setShowModal(false);
        showLanguageSwitcher();
    };
    const onSave = (val?: string) => {
        if (val) setText?.(val);
        onCancel();
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value;
        if (onChange) {
            onChange(inputValue); // Use the provided onChange handler
        } else {
            setText?.(inputValue); // Default behavior
        }
    };

    return (
        <>
            <TextField
                variant={variant}
                placeholder={placeholder}
                value={value}
                width={width}
                onChange={handleInputChange}
                sx={sx}
                icon={AIIcon}
                onClick={showAI}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                error={error}
                helperText={helperText}
                fullWidth={fullWidth}
            />
            <Modal open={showModal} onClose={() => {}}>
                <TextPromptModal
                    open={showModal}
                    value={value}
                    onCancel={onCancel}
                    onSave={onSave}
                    displayHistory={displayHistory}
                    setDisplayHistory={setDisplayHistory}
                    businessType={businessType}
                    language={language}
                />
            </Modal>
        </>
    );
});

export default AITextField;
